import { render, staticRenderFns } from "./xtxx_jc.vue?vue&type=template&id=890f254e&scoped=true&"
import script from "./xtxx_jc.vue?vue&type=script&lang=js&"
export * from "./xtxx_jc.vue?vue&type=script&lang=js&"
import style0 from "./xtxx_jc.vue?vue&type=style&index=0&id=890f254e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890f254e",
  null
  
)

export default component.exports